<template>
    <div class="tw-router-view">
        <router-view v-if="!designMode" v-slot="props">
            <!-- <keep-alive> -->
                <component :is="props?.Component" />
            <!-- </keep-alive> -->
        </router-view>
    </div>
</template>

<script>
export default {
    name: 'tw-router-view',
    setup() {
        const designMode = window.site && window.site.designMode;

        return {
            designMode
        }
    }
}
</script>

<style scoped>

</style>